export default __webpack_public_path__ + "img/eyoiEHzc.7901a190.svg";